import { render, staticRenderFns } from "./Shan2.vue?vue&type=template&id=083c0c56&"
import script from "./Shan2.vue?vue&type=script&lang=js&"
export * from "./Shan2.vue?vue&type=script&lang=js&"
import style0 from "./Shan2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports